import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../../helpers";
import { OmitStrict } from "../../utils";
import { DesignElementBase, DesignElementBrandedPart } from "./base";
import { DesignTokenType } from "./raw-element";
import { DesignTokenOrigin, DesignTokenOriginPart, DesignTokenTypedData } from "./tokens";

//
// Overrides
//

export const ThemeOverrideOriginPart = DesignTokenOriginPart;
export const ThemeOverrideOrigin = DesignTokenOrigin;

export const ThemeOverride = DesignTokenTypedData.and(
  z.object({
    tokenPersistentId: z.string(),
    origin: ThemeOverrideOrigin.optional()
      .nullable()
      .transform(v => v ?? undefined),
  })
);

export type ThemeOverride = z.infer<typeof ThemeOverride>;
export type ThemeOverrideOfType<T extends DesignTokenType> = Extract<ThemeOverride, { type: T }>;

//
// Theme data
//

export const ThemeElementData = z.object({
  value: z.object({
    overrides: z.array(ThemeOverride),
  }),
});

export type ThemeElementData = z.infer<typeof ThemeElementData>;

//
// Theme
//

export const ThemeOriginPart = z.object({});

export const ThemeOriginObject = z.object({
  id: z.string(),
  name: z.string(),
});

export const ThemeOriginSource = z.object({
  sourceId: z.string(),
  sourceObjects: z.array(ThemeOriginObject),
});

export const ThemeOrigin = z.object({
  sources: z.array(ThemeOriginSource),
});

export const Theme = DesignElementBase.extend(DesignElementBrandedPart.shape).extend({
  origin: ThemeOrigin.optional(),
  overrides: z.array(ThemeOverride),
  codeName: z.string(),
});

export type Theme = z.infer<typeof Theme>;
export type ThemeOrigin = z.infer<typeof ThemeOrigin>;
export type ThemeOriginSource = z.infer<typeof ThemeOriginSource>;
export type ThemeOriginObject = z.infer<typeof ThemeOriginObject>;

export type CreateTheme = DbCreateInputOmit<Theme>;
export type UpdateTheme = OmitStrict<DbUpdate<Theme>, "brandPersistentId" | "designSystemVersionId">;

export type ThemeDiff = {
  toCreate: CreateTheme[];
  toUpdate: UpdateTheme[];
};
